import IL_ILCE from "./trIlIlce.json";

export const CITIES = Object.keys(IL_ILCE);
export const norm = (s) => (s || "").trim().toLocaleUpperCase("tr").replace(/İ/g, "I").replace(/[ÇĞŞÖÜ]/g, (c) => ({ Ç: "C", Ğ: "G", Ş: "S", Ö: "O", Ü: "U" }[c]));
const BY_NORM = Object.fromEntries(CITIES.map((c) => [norm(c), c]));
// halk arasındaki / eski adlar → resmi il adı
const ALIASES = { IZMIT: "KOCAELİ", ANTEP: "GAZİANTEP", URFA: "ŞANLIURFA", MARAS: "KAHRAMANMARAŞ", AFYON: "AFYONKARAHİSAR", ICEL: "MERSİN" };

export const cityKey = (c) => BY_NORM[norm(c)] || "";
export const districtsOf = (city) => IL_ILCE[cityKey(city)] || [];

const lev = (a, b) => {
  const m = a.length, n = b.length; if (!m) return n; if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    prev = cur;
  }
  return prev[n];
};

// yanlış yazılmış il için en yakın resmi il (takma ad → tam eşleşme → en fazla 2 harf farkı)
export function suggestCity(c) {
  const k = norm(c);
  if (!k) return "";
  if (BY_NORM[k]) return BY_NORM[k];
  if (ALIASES[k]) return ALIASES[k];
  let best = "", bestD = 3;
  for (const city of CITIES) { const d = lev(k, norm(city)); if (d < bestD) { bestD = d; best = city; } }
  return best;
}

// ilçe resmi listede mi (yazım/büyük-küçük farkı yok sayılır) → resmi yazımı, yoksa ""
export const districtKey = (city, d) => districtsOf(city).find((x) => norm(x) === norm(d)) || "";

// yanlış yazılmış / eski adlı ilçe için en yakın resmi ilçe (eski ad → yeni ad, benzersiz ön ek, en fazla 2 harf farkı, tek "MERKEZ" eşleşmesi)
const DISTRICT_ALIASES = { "ISTANBUL:EYUP": "EYÜPSULTAN", "ANKARA:KAZAN": "KAHRAMANKAZAN" };
export function suggestDistrict(city, d) {
  const list = districtsOf(city); const k = norm(d);
  if (!list.length || !k) return "";
  const exact = districtKey(city, d); if (exact) return exact;
  const alias = DISTRICT_ALIASES[`${norm(cityKey(city))}:${k}`]; if (alias) return alias;
  const pre = list.filter((x) => norm(x).startsWith(k) || k.startsWith(norm(x))); if (pre.length === 1 && k.length >= 4) return pre[0];
  let best = "", bestD = 3;
  for (const x of list) { const dist = lev(k, norm(x)); if (dist < bestD) { bestD = dist; best = x; } }
  if (!best && k === "MERKEZ") { const m = list.filter((x) => norm(x).includes("MERKEZ")); if (m.length === 1) return m[0]; }
  return best;
}
